<style scoped>
.w-title {
    margin-top: 160px;
    margin-bottom: 60px;

    font-style: normal;
    font-weight: 700;
    font-size: 48px !important;
    line-height: 65px;

    color: #525252;
}
.content-wrapper {
    background: linear-gradient(175.57deg, rgba(150, 255, 243, 0.3) -12.02%, rgba(137, 232, 198, 0.3) 138.39%);
    border: 4px solid rgba(255, 255, 255, 0.6);
    backdrop-filter: blur(100px); 
    height: 416px;
    background-image: url('../../assets/approved_bg.png');
}

.content {
    width: 1030px;
    height: 316px;

    background: #FFFFFF;
    box-shadow: 58px 42px 28px rgba(110, 215, 93, 0.01), 
        32px 23px 24px rgba(110, 215, 93, 0.05), 
        14px 10px 18px rgba(110, 215, 93, 0.09), 
        4px 3px 10px rgba(110, 215, 93, 0.1), 
        0px 0px 0px rgba(110, 215, 93, 0.1);
    border-radius: 20px;
}
</style>

<template>
    <div>
        <div class="w-title text-center">Вам одобрили займ!</div>
        <div class="content-wrapper d-flex align-center justify-center">
            <div class="content px-10 py-12">
                <img src="../../assets/banks/creditplus.png" />

                <v-row style="margin-top: 100px;" align="center">
                    <v-col cols="6" >
                        <v-row align="center">
                            <span class="ml-8">Рейтинг</span>
                            <span class="ml-8">
                                <img src="../../assets/star.png" />
                            </span>
                        </v-row>
                    </v-col>
                    <v-col cols="6" class="text-right">
                        <Button white>Все условия</Button>
                        <Button class="ml-8">Оформить</Button>
                    </v-col>

                </v-row>
            </div>
        </div>
    </div>
</template>

<script>

export default {
    
}
</script>

